import * as Yup from 'yup'
import {getTypeDocument} from '../features/central/util/functions'
import {formatParseDate} from './dates'

export const newModuleSchema = Yup.object().shape({
  // Id: Yup.string().required(),
  CompaniaId: Yup.string().required('Compañía es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
  TipoModuloId: Yup.string().required('Tipo de módulo es requerido'),
  Codigo: Yup.string().required('Nomenclatura es requerida'),
  // TipoPreAsignacionId: Yup.string().required('Preasignación es requerido'),
  SexoId: Yup.string().required('Sexo es requerido'),
  TipoBanioId: Yup.string().required('Tipo de Baño es requerido'),
  NroPisos: Yup.number()
    .typeError('Nro de Pisos es requerido')
    .required('Nro de Pisos es requerido'),
  // NivelId: Yup.string().required('Nivel es requerido'),
  NroHabitaciones: Yup.number()
    .typeError('Nro de Habitaciones es requerido')
    .required('Nro de Habitaciones debe ser requerido'),
  PrioridadAsignacion: Yup.number()
    .typeError('Nro de secuencia de asignación es requerido')
    .required('Nro de secuencia de asignacion es requerido'),
  EstadoModuloId: Yup.string().required('Estado es requerido'),
  // TipoEdificacionId: Yup.string().required('Tipo de Edificación es requerido'),
})

export const newRoomSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañía es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
  TipoModuloId: Yup.string().required('Tipo de Módulo es requerido'),
  TipoHabitacionId: Yup.string().required('Tipo de Habitación es requerido'),
  Codigo: Yup.string().required('Nomenclatura es requerida'),
  TipoPreAsignacionId: Yup.string().required('Preasignación es requerido'),
  SexoId: Yup.string().required('Sexo es requerido'),
  TipoBanioId: Yup.string().required('Tipo de Baño es requerido'),
  NivelId: Yup.string().required('Piso es requerido'),
  // NroHabitaciones: Yup.string().required('Numero de Habitaciones es requerido'),
  NroCamas: Yup.number().typeError('Número de camas es requerido').required(),
  PrioridadAsignacion: Yup.string().required('Nro de secuencia de asignación es requerido'),
  EstadoHabitacionId: Yup.string().required('Estado de Habitación es requerido'),
  SubEstadoHabitacionId: Yup.string().required('Sub Estado de Habitación es requerido'),
  ModuloId: Yup.string().required('Módulo es requerido'),
  // CargoId: Yup.string().required('Cargo es requerido'),
  // TurnoId: Yup.string().required('Turno es requerido')
  // empresaId: Yup.string().required('Empresa Lotización es requerido')
})

export const newRoomModalSchema = Yup.object().shape({
  TipoHabitacionId: Yup.string().required('El Tipo de habitación es requerido'),
  Codigo: Yup.string().required('Nomenclatura de habitación es requerido'),
  EstadoHabitacionId: Yup.string().required('El Estado es requerido'),
  SubEstadoHabitacionId: Yup.string().required('El Sub estado es requerido'),
  TipoPreAsignacionId: Yup.string().required('Preasignación es requerido'),
  SexoId: Yup.string().required('El sexo es requerido'),
  TipoBanioId: Yup.string().required('Tipo de baño es requerido'),
  NivelId: Yup.string().required('Nivel es requerido'),
  NroCamas: Yup.number()
    .typeError('Número de camas debe ser númerico')
    .required('Número de camas es requerido'),
  PrioridadAsignacion: Yup.number()
    .typeError('Nro de secuencia de asignación debe ser númerico')
    .required('Nro de secuencia de asignación es requerido'),
  ModuloId: Yup.string().required('Modulo es requerido'),
})

export const newFurnitureModalSchema = Yup.object().shape({
  ModuloId: Yup.string().required('Modulo es requerido'),
  TipoMobiliarioId: Yup.string().required('Tipo de Mobiliario es requerido'),
  Codigo: Yup.string().required('Código de mobiliario es requerido'),
  Descripcion: Yup.string().required('Descripción es requerido'),
  Observaciones: Yup.string().required('Observaciones es requerido'),
})

export const newBedSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañía es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
  ModuloId: Yup.string().required('Nomenclatura de Módulo es requerido'),
  HabitacionId: Yup.string().required('Nomenclatura de Habitación es requerido'),
  Codigo: Yup.string().required('Nomenclatura de Cama es requerida'),
  // Descripcion: Yup.string().required('Descripcion es requerido'),
  TipoCamaId: Yup.string().required('Tipo de Cama es requerido'),
  EstadoCamaId: Yup.string().required('Estado de Cama es requerido'),
  SubEstadoCamaId: Yup.string().required('Sub estado de Cama es requerido'),
  FechaFinCC: Yup.string()
    .nullable()
    .when('CamaCaliente', {
      is: true,
      then: Yup.string()
        .nullable()
        .required('Fecha Fin es obligatorio')
        .test('is-greater', 'La Fecha Fin debe ser posterior a la Fecha Inicio', function (value) {
          const {FechaInicio} = this.parent
          const fechaInicio = formatParseDate(FechaInicio)
          const fechaFin = formatParseDate(value)

          return fechaFin >= fechaInicio
        }),
      otherwise: Yup.string().nullable().notRequired(),
    }),
  // FechaFinCC: Yup.string
  // MedidaCamaId: Yup.string().required('Medida de Cama es requerido'),
  // Observaciones: Yup.string().required('Observaciones es requerido'),
  // CamaCaliente: Yup.boolean().required('Cama Caliente es requerido')
})

export const newBathRoomModalSchema = Yup.object().shape({
  TipoBanioId: Yup.string().required('Tipo de Baño es requerido'),
  Codigo: Yup.string().required('Código de baño es requerido'),
  SexoId: Yup.string().required('Sexo es requerido'),
  Observaciones: Yup.string().required('Observaciones es requerido'),
})

export const newBookingSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañía es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
  TipoEmpresaId: Yup.string().required('Tipo de Empresa es requerido'),
  // UsuarioId: Yup.string().required('Cliente/Interlocutor es requerido'),
  ClienteContratista: Yup.string().required('Cliente/Contratista es requerido'),
  TipoModuloId: Yup.string().required('Tipo de Módulo es requerido'),
  // TipoHabitacionId: Yup.string().required('Tipo de Habitación es requerido'),
  NroCamas: Yup.string().required('Nro de Camas es requerido'),
  FechaInicio: Yup.string().required('Fecha Inicio es requerido'),
  FechaFin: Yup.string().required('Fecha Fin es requerido'),
  // NroHuespedHombre: Yup.string().required('Nro de Hombres es requerido'),
  // NroHuespedMujer: Yup.string().required('Nro de Mujeres es requerido'),
})

export const newGuestSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañía es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
  UsuarioId: Yup.string().required('Usuario es requerido'),
  TipoHuespedId: Yup.string().required('Estatus es requerido'),
  TipoEstadiaId: Yup.string().required('Tipo de Estadía es requerido'),
  ModuloId: Yup.string()
    .nullable()
    .when('tipoEstadia', {
      is: (tipoEstadia) => tipoEstadia === 'PERMANENTE',
      then: Yup.string().nullable().required('Módulo es requerido'),
    }),
  HabitacionId: Yup.string()
    .nullable()
    .when('tipoEstadia', {
      is: (tipoEstadia) => tipoEstadia === 'PERMANENTE',
      then: Yup.string().nullable().required('Habitación es requerida'),
    }),
  CamaId: Yup.string()
    .nullable()
    .when('tipoEstadia', {
      is: (tipoEstadia) => tipoEstadia === 'PERMANENTE',
      then: Yup.string().nullable().required('Cama es requerida'),
    }),
})

export const cancellationsChangesFilterSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañia es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
  // HuespedNroDoc: Yup.string().required('Huesped es requerido'),
  // NroReserva: Yup.string().required('Nro de reserva es requerido'),
})

export const cancellationsChangesSchema = Yup.object().shape({
  MotivoAnulacionId: Yup.string().required('El motivo es obligatorio'),
  FechaCheckout: Yup.string().required('Fecha Checkout es obligatorio'),
  FechaInicio: Yup.string().when('CrearReserva', {
    is: true,
    then: Yup.string().required('Fecha Inicio Programada es obligatorio'),
    otherwise: Yup.string().notRequired(),
  }),
  FechaFin: Yup.string().when('CrearReserva', {
    is: true,
    then: Yup.string()
      .required('Fecha Fin Programada es obligatorio')
      .test('is-greater', 'La Fecha Fin debe ser posterior a la Fecha Inicio', function (value) {
        const {FechaInicio} = this.parent
        return new Date(value) >= new Date(FechaInicio)
      }),
    otherwise: Yup.string().notRequired(),
  }),
  ModuloId: Yup.string().when('CrearReserva', {
    is: true,
    then: Yup.string().required('Modulo es obligatorio'),
    otherwise: Yup.string().notRequired(),
  }),
  HabitacionId: Yup.string().when('CrearReserva', {
    is: true,
    then: Yup.string().required('Habitación es obligatorio'),
    otherwise: Yup.string().notRequired(),
  }),
  CamaId: Yup.string().when('CrearReserva', {
    is: true,
    then: Yup.string().required('Cama es obligatorio'),
    otherwise: Yup.string().notRequired(),
  }),
  FechaCheckIn: Yup.string().when('CrearCheckIn', {
    is: true,
    then: Yup.string().required('Fecha Checkin es obligatorio'),
    otherwise: Yup.string().notRequired(),
  }),

  // HuespedId: Yup.string().when('ReclamanteId', {
  //   is: '+BPMQ4keWgI=',
  //   then: Yup.string().required('Los datos del reclamante son obligatorios'),
  //   otherwise: Yup.string().notRequired(),
  // }),
  // ColaboradorId: Yup.string().when('ReclamanteId', {
  //   is: '+BPMQ4keWgI=',
  //   then: Yup.string().notRequired(),
  //   otherwise: Yup.string().required('Los datos del reclamante son obligatorios'),
  // }),
})

export const availabilitySchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañia es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
})

export const checkInSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañia es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
})
export const checkInListSchema = Yup.object().shape({})

export const checkOutListSchema = Yup.object().shape({})

export const guestHistorySchema = Yup.object().shape({
  CompaniaId: Yup.string().required('La compañía es requerida'),
  ClienteId: Yup.string().required('El cliente es requerido'),
  SiteId: Yup.string().required('El sitio es requerido'),
  CampamentoId: Yup.string().required('El campamento es requerido'),
  NroDoc: Yup.string(),
  ModuloId: Yup.string(),
  HabitacionId: Yup.string().nullable().notRequired(),
  CamaId: Yup.string().nullable().notRequired(),
  FechaEstadiaIni: Yup.string().required('La fecha de inicio es requerida'),
  FechaEstadiaFin: Yup.string().required('La fecha de fin es requerida'),
})
.test('modulo-required', function (values) {
  const { NroDoc, ModuloId } = values;
  if (!NroDoc && !ModuloId) {
    return this.createError({
      path: 'NroDoc',
      message: 'Debe ingresar el número de documento o el módulo',
    });
  }
  return true;
});

export const checkinAppSchema = Yup.object().shape({
  FechaEstadiaIni: Yup.string().required('Fecha Inicio es requerido'),
  FechaEstadiaFin: Yup.string().required('Fecha Fin es requerido'),
})

export const billingSchema = Yup.object().shape({
  FechaPeriodoIni: Yup.string().required('Fecha Inicio es requerido'),
  FechaPeriodoFin: Yup.string().required('Fecha Fin es requerido'),
})

export const savebillingSchema = Yup.object().shape({
  FechaPeriodoIni: Yup.string().required('Fecha Inicio es requerido'),
  FechaPeriodoFin: Yup.string().required('Fecha Fin es requerido'),
  DescripcionReporte: Yup.string().required('Descripción es requerido'),
})

export const ratioCheckinoutSchema = Yup.object().shape({
  FechaIni: Yup.string().required('Fecha Inicio es requerido'),
  FechaFin: Yup.string().required('Fecha Fin es requerido'),
})

export const ratioRoomingListSchema = Yup.object().shape({
  Fecha: Yup.string().required('Fecha es requerido'),
})

export const ratioSalesSummarySchema = Yup.object().shape({
  FechaIni: Yup.string().required('Fecha inicial es requerido'),
  FechaFin: Yup.string().required('Fecha fin es requerido'),
})

export const ratioSalesDetailSchema = Yup.object().shape({
  FechaIni: Yup.string().required('Fecha inicial es requerido'),
  FechaFin: Yup.string().required('Fecha fin es requerido'),
})

export const ratioOccupancyCustomerSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañia es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  Fecha: Yup.string().required('Fecha es requerido'),
})

export const ratioOccupancyBedSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañia es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  FechaIni: Yup.string().required('Fecha inicial es requerido'),
  FechaFin: Yup.string().required('Fecha fin es requerido'),
})

export const ratioSummaryStaySchema = Yup.object().shape({
  FechaIni: Yup.string().required('Fecha Inicio de Estadía es requerido'),
  FechaFin: Yup.string().required('Fecha Fin de Estadía es requerido'),
})

export const reportOccupancySchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañia es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
  nroDiaInicio: Yup.string()
    .nullable()
    .when('mesCompleto', {
      is: false,
      then: Yup.string()
        .typeError('Nro Dia Inicio es requerido')
        .required('Nro Dia Inicio es requerido'),
      otherwise: Yup.string().notRequired(),
    }),
  nroDiaFin: Yup.string()
    .nullable()
    .when('mesCompleto', {
      is: false,
      then: Yup.string()
        .typeError('Nro Dia Fin es requerido')
        .required('Nro Dia Fin es requerido')
        .test(
          'fecha-mayor',
          'La fecha de inicio debe ser mayor a la fecha de fin',
          function (value) {
            const {nroDiaInicio} = this.parent
            if (nroDiaInicio && value) {
              return nroDiaInicio > value
            }
            return true
          },
        )
        .test(
          'diferencia-menor-a-un-dia',
          'La diferencia entre las fechas debe ser menor a 1 día',
          function (value) {
            const {nroDiaInicio} = this.parent
            if (nroDiaInicio && value) {
              const diffInDays = Math.abs(value - nroDiaInicio)
              return diffInDays <= 1
            }
            return true
          },
        ),
      otherwise: Yup.string().notRequired(),
    }),
})
export const reportTableOccupancySchema = Yup.object().shape({
  NroDocumento: Yup.string().required('Este campo es requerido'),
})
export const checkinAutoSchemas = [
  Yup.object({
    operationType: Yup.string().required('Operación es requerida').label('Operación'),
  }),
  Yup.object({
    tipoDocumentoId: Yup.string()
      .required('Tipo de Documento es requerido')
      .label('Tipo de Documento'),
    numeroDocumento: Yup.string()
      .test({
        name: 'dynamicValidation',
        message: 'Cantidad de carácteres no validos',
        test: async function (texto) {
          const tipo = this.parent.tipoDocumentoId
          if (!tipo) {
            return true // Evita la validación si el campo tipoDocumentoId está vacío
          }
          const maxLengthOptions = await getTypeDocument()
          const tipoDocumento = maxLengthOptions.find((item) => item.value === tipo)
          if (!tipoDocumento) {
            return true // Evita la validación si no se encuentra el tipo
          }
          const length = tipoDocumento.length
          if (texto && Number(texto.length) !== Number(length)) {
            return this.createError({
              message: `Por favor, no escribas menos de ${length} caracteres.`, // Modifica el mensaje de error
              path: this.path,
            })
          }
          return true
        },
      })
      .required('Numero de Documento requerido'),
  }),
  Yup.object({}),
  Yup.object({}),
]

export const checkinParkingSchemas = [
  Yup.object({
    tipoDocumentoId: Yup.string()
      .required('Tipo de Documento es requerido')
      .label('Tipo de Documento'),
    numeroDocumento: Yup.string()
      .test({
        name: 'dynamicValidation',
        message: 'Cantidad de carácteres no validos',
        test: async function (texto) {
          const tipo = this.parent.tipoDocumentoId
          if (!tipo) {
            return true // Evita la validación si el campo tipoDocumentoId está vacío
          }
          const maxLengthOptions = await getTypeDocument()
          const tipoDocumento = maxLengthOptions.find((item) => item.value === tipo)
          if (!tipoDocumento) {
            return true // Evita la validación si no se encuentra el tipo
          }
          const length = tipoDocumento.length
          if (texto && Number(texto.length) !== Number(length)) {
            return this.createError({
              message: `Por favor, no escribas menos de ${length} caracteres.`, // Modifica el mensaje de error
              path: this.path,
            })
          }
          return true
        },
      })
      .required('Numero de Documento requerido'),
  }),
  Yup.object({}),
  Yup.object({}),
]

export const schemaInspectionSearch = Yup.object().shape({
  companiaId: Yup.string().required('La compañía es obligatorio'),
  clienteId: Yup.string().required('El cliente es obligatorio'),
  siteId: Yup.string().required('El site es obligatorio'),
  puntoId: Yup.string().optional(),
  fechaRango: Yup.array().length(2).required('El rango de fechas es obligatorio').of(Yup.date()),
  tipoAdministracion: Yup.string(),
})

export const schemaTerms = Yup.object().shape({
  CompaniaId: Yup.string().required('La compañía es obligatorio'),
  ClienteId: Yup.string().required('El cliente es obligatorio'),
  SiteId: Yup.string().required('El site es obligatorio'),
  TyC: Yup.string().required('Los términos y condiciones son obligatorio'),
  ModRecepcion: Yup.string().required('La recepción es obligatorio'),
  ModParqueoDeBuses: Yup.string().required('El parqueo de buses es obligatorio'),
  ModAutoservicioTotem: Yup.string().required('El autoservicio es obligatorio'),
  ModCheckInAppHuesped: Yup.string().required('App Huesped es obligatorio'),
})

export const reportOccupancy2Schema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañia es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
  nroDiaFin: Yup.string().required('Fecha es requerido'),
})

// --------------------valuation

export const reportValuationSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañia es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
  fechaInicio: Yup.string().when('mesCompleto', {
    is: false,
    then: Yup.string().typeError('Fecha Inicio es requerido').required('Fecha Inicio es requerido'),
    otherwise: Yup.string().nullable().notRequired(),
  }),
  fechaFin: Yup.string().when('mesCompleto', {
    is: false,
    then: Yup.string().typeError('Fecha Fin es requerido').required('Fecha Fin es requerido'),
    otherwise: Yup.string().nullable().notRequired(),
  }),
})

export const newRelevoUsuarioSchema = Yup.object().shape({
  // CampamentoId: Yup.string().required('Campamento es requerido'),
  // UsuarioId: Yup.string().required('Usuario principal es requerido'),
  NuevoUsuarioId: Yup.string().required('Usuario relevo es requerido'),
  // RelevoId: Yup.string().required('Relevo es requerido'),
})

export const newRelevoHabitacionSchema = Yup.object().shape({
  // CampamentoId: Yup.string().required('Campamento es requerido'),
  // UsuarioId: Yup.string().required('Usuario principal es requerido'),
  ModuloId: Yup.string().required('El modulo es requerido'),
  HabitacionId: Yup.string().required('La habitación es requerida'),
  CamaId: Yup.string().required('La cama es requerida'),
  // RelevoId: Yup.string().required('Relevo es requerido'),
})

//retired guest

export const retiredGuestFilterSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañia es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
  FechaCheckOutIni: Yup.string().required('Fecha Inicio de CheckOut es requerido'),
  FechaCheckOutFin: Yup.string().required('Fecha Fin de CheckOut es requerido'),
})